var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"unpack-right"},[(_vm.type === 'classify')?_c('RightClassify',{attrs:{"chapterId":_vm.detailData.id},on:{"unpack":_vm.unpack}}):_vm._e(),(_vm.type === 'result')?_c('RightResult',{attrs:{"chapterId":_vm.detailData.id,"result":_vm.detailData.result},on:{"unpack":_vm.unpack}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }